"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _AppIcon = _interopRequireDefault(require("../ImagesAndIcons/AppIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
// Components
const GameOptionWrapper = _styledComponents.default.div.withConfig({
  displayName: "GameOption__GameOptionWrapper",
  componentId: "design-system__bw4f3g-0"
})(["& > a{display:flex;text-decoration:none;margin:", " 0;}& > a:hover{background-color:", ";}dd,dt{height:", ";box-sizing:border-box;}dt img{cursor:pointer;}dd{margin-inline-start:", ";display:block;color:", ";text-decoration:none;font-size:", ";width:100%;height:", ";line-height:", ";}"], _BaseTheme.default.distance.tiny, _BaseTheme.default.colors.bluegray, _BaseTheme.default.distance.double, _BaseTheme.default.distance.tiny, _BaseTheme.default.colors.black, _BaseTheme.default.type.size.tiny, _BaseTheme.default.distance.double, _BaseTheme.default.type.lineHeight.extra);

const GameOption = _ref => {
  let {
    to,
    label,
    appIcon,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(GameOptionWrapper, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    key: label,
    onClick: onClick,
    to: to
  }, /*#__PURE__*/_react.default.createElement("dt", null, appIcon && /*#__PURE__*/_react.default.createElement(_AppIcon.default, {
    type: appIcon,
    size: "32"
  })), /*#__PURE__*/_react.default.createElement("dd", null, label)));
};

GameOption.propTypes = {
  to: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  appIcon: _propTypes.default.string
};
GameOption.defaultProps = {
  appIcon: '',
  onClick: null
};
var _default = GameOption;
exports.default = _default;